// extracted by mini-css-extract-plugin
export var footer = "style-module--footer--zERoK";
export var inner = "style-module--inner--90jcD";
export var links = "style-module--links--GNSVk";
export var text = "style-module--text--MgDjK";